/**
 * Route guard. Renders children only if authenticated; otherwise redirects
 * to /login with a `from` state so the user lands back where they started
 * after sign-in.
 */

import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { Spinner } from "@blueprintjs/core";

import { useAuth } from "../contexts/auth-context";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div data-testid="require-auth"
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          background: "var(--bp-bg)",
        }}
      >
        <Spinner />
      </div>
    );
  }

  if (status === "unauthenticated") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
